/** Tipos aceites pela API (FQCN PHP) para anexos de áudio de feedback */
export const FEEDBACK_AUDIO_CORRECAO = 'App\\Models\\Correcao';
export const FEEDBACK_AUDIO_AVALIACAO = 'App\\Models\\AvaliacaoRedacao';
export const FEEDBACK_AUDIO_COMENTARIO = 'App\\Models\\Comentario';
